import { EventEmitter } from '@bhb-frontend/utils/lib/events';

export const event = new EventEmitter();
